import React from 'react'
// images
import Image from '../assets/avatar.png';
// icons
import {FaGithub, FaLinkedinIn} from 'react-icons/fa';
// type animation
import {TypeAnimation} from 'react-type-animation';
// motion
import {motion} from 'framer-motion';
// variants
import {fadeIn} from '../variants';
import { Link } from 'react-scroll';

const Banner = () => {
  return (
    <section 
    className='min-h-[85vh] lg:min-h-[78vh] flex
    items-center' id='home'>
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center
        lg:gap-x-12'>
          {/* text */}
          <div className='flex-1 text-center font-secondary lg:text-left'>
            <motion.h1 
            variants={fadeIn('up', 0.3)} 
            initial="hidden" 
            whileInView={'show'} 
            viewport={{once: false, amount: 0.7 }} 
            className='text-[40px] font-bold leading-[0.8]
            lg:text-[90px]'>
              PRISCILLA <span>HUMEAU</span>
            </motion.h1>
            <motion.div 
            variants={fadeIn('up', 0.4)} 
            initial="hidden" 
            whileInView={'show'} 
            viewport={{once: false, amount: 0.7}} 
             className='mb-6 text-[35px] lg:text-[50px] font-secondary
            font-semibold uppercase leading-[1]'>
              <span className='text-white mr-4'>Développeuse</span>
              <TypeAnimation 
              sequence={[
                'React Js',
                2000,
                'React Native',
                2000,
                'Fullstack',
                2000,
                'Front-end',
                2000,
              ]}
              speed={50}
              className='text-accent'
              wrapper='span'
              repeat={Infinity}
              />
            </motion.div>
            <motion.p  
            variants={fadeIn('up', 0.5)} 
            initial="hidden" 
            whileInView={'show'} 
            viewport={{once: false, amount: 0.7}} 
            className='mb-8 max-w-lg mx-auto lg:mx-0 text-[30px]'> 
              Je développe des interfaces utilisateurs, applications et sites web
            </motion.p>
            <motion.div 
            variants={fadeIn('up', 0.6)} 
            initial="hidden" 
            whileInView={'show'} 
            viewport={{once: false, amount: 0.7}} 
            className='flex max-w-max gap-x-6 items-center mb-9
            mx-auto lg:mx-0'>
              <a href='mailto:priscildu49@hotmail.fr'>
                <button className='btn btn-sm'>Me Contacter</button>
              </a>
              <Link to='work' activeClass='active' smooth={true}
                spy={true} className='text-gradient btn-link cursor-pointer'>
                Mon Portfolio
              </Link>
            </motion.div>
            {/* socials */}
            <motion.div 
            variants={fadeIn('up', 0.7)} 
            initial="hidden" 
            whileInView={'show'} 
            viewport={{once: false, amount: 0.7}} 
            className='flex text-[30px] gap-x-6 max-w-max mx-auto
            lg:mx-0 cursor-pointer'>
              <a  href="https://github.com/PriscilH">
                <FaGithub/>
              </a> 
              <a href='https://www.linkedin.com/in/priscilla-h-b784b1b8/'>
                <FaLinkedinIn/>
              </a>
            </motion.div>
          </div>
          {/* image */}
          <motion.div 
          variants={fadeIn('down', 0.5)} 
          initial="hidden" 
          whileInView={'show'} 
          className='hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]'>
            <img style={{height: "400px", borderRadius: "110%"}} src={Image} alt='' />
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Banner